import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

// icons
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DashBoardPageHeaderPage from "../components/DashBoard/DashBoardHeaderPage";
import ShipmentReport from "../components/ShipmentReport";
import ItemHistoryReport from "../components/ItemHistoryReport";
import StorageReport from "../components/StorageReport";
import FaultyReport from "../components/FaultyReport";
import ProcessedReport from "../components/ProcessedReport";
import TotalStockReport from "./TotalStockReport";
import FormSelect from "../forms/FormSelect";
import { useFormik } from "formik";
import URLS from "../services/urlConstants";
import { get } from "../services/apiMethods";
import { LoadingButton } from "@mui/lab";
import { Download } from "@mui/icons-material";
import PageHeader from "../components/PageHeader";
import { toast } from "react-toastify";
import { downloadExcel } from "../utils/utilities";

const yearData = [2025, 2026, 2027, 2028, 2029, 2030].map((year) => ({
  label: year.toString(),
  value: year,
}));

const monthData = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
].map((month, index) => ({
  label: month,
  value: month,
}));

export default function BillingReports() {
  const [warehouseData, setWarehouseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subFamilies, setSubFamilies] = useState([]);
  const [ownerCodes, setOwnerCodes] = useState([]);

  const getSubfamlies = async () => {
    try {
      const { data } = await get(URLS.subFamily.list, {
        params: {
          warehouse: formik.values.warehouse,
        },
      });

      setSubFamilies(
        data.result.map((s) => ({
          ...s,
          label: s.name,
          value: s._id,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getWarehouseDetails = async () => {
    try {
      const { data } = await get(URLS.warehouse.list);
      setWarehouseData(
        data?.result.map((w) => ({
          ...w,
          label: `${w.code}`,
          value: w._id,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWarehouseDetails();
  }, []);

  const donwloadBillingReport = async (values) => {
    try {
      setLoading(true);
      const { data, status } = await get(URLS.items.donwloadBillingReport, {
        params: {
          warehouseId: values.warehouse,
          month: values.month,
          year: values.year,
          subfamilyForCleaning: values.subfamilyForCleaning,
          ownerCodeIds: values.ownerCodeIds,
        },
        responseType: "blob",
        validateStatus: (status) => status < 500,
      });
      if (status === 200) {
        let seletedWarehoouse = warehouseData.find(
          (s) => s.value == formik.values.warehouse
        )?.label;
        downloadExcel(
          data,
          `${seletedWarehoouse} BILLING ${formik.values.month} ${formik.values.year}`
        );
      } else {
        const errorText = await new Response(data).text();
        toast.error(JSON.parse(errorText)?.message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      warehouse: "",
      ownerCodeIds: [],
      month: new Date().toLocaleString('default', { month: 'long' }),
      year: new Date().getFullYear(),
      subfamilyForCleaning: [],
    },
    onSubmit: donwloadBillingReport,
    enableReinitialize: true,
  });

  const getOwnerCodes = async () => {
    try {
      const { data: ownerGroupData } = await get(URLS.ownerGroup.list, { 
        params: { warehouse: formik.values.warehouse } 
      });
      
      if (!ownerGroupData?.result?.length) {
        setOwnerCodes([]);
        return;
      }

      let ownerGroups = ownerGroupData.result.map(o => o._id);

      const { data: ownerCodesData } = await get(URLS.ownerCode.list, { 
        params: { ownerGroup: { $in: ownerGroups } } 
      });

      if (!ownerCodesData?.result?.length) {
        console.log('No owner codes found for owner groups');
        setOwnerCodes([]);
        return;
      }

      const formattedOwnerCodes = ownerCodesData.result.map(o => ({
        label: o.name,
        value: o._id,
      }));
      setOwnerCodes(formattedOwnerCodes);
    } catch (error) {
      console.error('Error fetching owner codes:', error);
      toast.error('Failed to fetch owner codes');
      setOwnerCodes([]);
    }
  }

  useEffect(() => {
    if (formik.values.warehouse) {
      getSubfamlies();
      getOwnerCodes();
    }
  }, [formik.values.warehouse]);

  return (
    <>
      <PageHeader
        title="Billing Reports"
        addButtonDisabled={true}
        showAdd={false}
        showAddField={false}
      />
      <Grid
        container
        spacing={2}
        component={"form"}
        onSubmit={formik.handleSubmit}
      >
        <Grid item xs={12} sm={6} md={3}>
          <FormSelect
            options={warehouseData}
            formik={formik}
            name="warehouse"
            label="Select Warehouse"
            required={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormSelect
            options={ownerCodes}
            formik={formik}
            name="ownerCodeIds"
            label="Select OwnerCode"
            required={true}
            multiple={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormSelect
            formik={formik}
            name="subfamilyForCleaning"
            label="Select Sub-family to exclude For Cleaning"
            required={true}
            options={subFamilies}
            multiple={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormSelect
            options={yearData}
            formik={formik}
            name="year"
            label="Select Year"
            required={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormSelect
            options={monthData}
            formik={formik}
            name="month"
            label="Select Month"
            required={true}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          display="flex"
          justifyContent={"flex-end"}
          alignItems="center"
        >
          <LoadingButton
            loading={loading}
            startIcon={<Download />}
            variant="contained"
            size="small"
            type="submit"
          >
            Download Report
          </LoadingButton>
        </Grid>
      </Grid>
    </>
  );
}
